export default __webpack_public_path__ + "static/media/p3.f061b052.png";